import { FC, forwardRef } from 'react';
import { FAIcon, IconStyle } from '../../Icons/Icons';
import { Theme } from '../../types/enums';
import { CheckboxPropsTypes, CheckboxTheme } from './types/propsType';
import styles from './Checkbox.module.scss';
import { CheckboxVariant } from './types/enums';

const Checkbox: FC<CheckboxPropsTypes> = forwardRef<HTMLInputElement, CheckboxPropsTypes>(
  ({ text, disabled, checked = false, theme = Theme.BLACK, variant, subText, ...restProps }, ref) => {
    function renderInputType() {
      return (
        <input
          {...restProps}
          id={`checkbox-${restProps.id}`}
          ref={ref}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          data-testid="checkbox-test-id"
        />
      );
    }

    const checkboxBorderClass = checked ? 'checkbox-border-filled' : 'checkbox-border-empty';

    let variantClassName = styles[CheckboxVariant.DEFAULT];
    if (variant === CheckboxVariant.LONG_TEXT) {
      variantClassName = styles[CheckboxVariant.LONG_TEXT];
    }
    return (
      <>
        <label
          className={`
      ${styles['checkbox']}
      ${variantClassName}
      ${styles[theme]}
      ${styles[checkboxBorderClass]}
      ${disabled && styles['disabled']} 
      `}
          data-testid="checkbox-container-test-id"
        >
          <section className={styles['checkbox-main-content']}>
            {renderInputType()}
            <span className={`${styles['checkbox-border']}`}>
              <FAIcon
                iconName={checked ? 'check' : 'square'}
                iconStyle={checked ? IconStyle.SOLID : IconStyle.REGULAR}
                theme={theme}
                className={`${styles['checkmark']}`}
              />
            </span>
            {text && text !== "" && (
              <label htmlFor={`checkbox-${restProps.id}`} className={styles['checkbox-content']}>
                <span className={styles['label']}>{text}</span>
              </label>
            )}
          </section>
          {subText && <span className={styles['label-details']}>{subText}</span>}
        </label>
      </>
    );
  },
);
Checkbox.displayName = 'Checkbox';
export default Checkbox;
export type { CheckboxTheme, CheckboxPropsTypes };
